import { Variant, Product, Option } from "./types";

export const CSV_TEMPLATE = "title;description;price;category\n;;0;;";

export const DEFAULT_PRODUCT: Omit<Product, "id"> = {
  title: "",
  slug: "",
  description: "",
  category: undefined,
  images: [],
  originalPrice: 0,
  price: 0,
  type: "available",
  featured: false,
  badges: [],
  options: [],
  createdAt: 1594090800000,
  updatedAt: 1594090800000,
  handleStock: false,
  currentStock: 0,
};

export const DEFAULT_PRODUCT_VARIANT: Omit<Variant, "id"> = {
  title: "",
  count: 1,
  options: [],
  value: [],
  required: false,
};

export const DEFAULT_PRODUCT_OPTION: Omit<Option, "id"> = {
  title: "",
  price: 0,
  enabled: true,
  handleStock: false,
  currentStock: 0,
};

export { MAX_PRODUCT_BADGES, PRODUCT_BADGE_ICONS } from "@pency/api/product/constants";
